<div class="dialog">
    <div class="dialog-header">
        <h2>
            {{ offer.name }}
            <small>{{ offer.code }}</small>
        </h2>
        <a class="dialog-close" (click)="onCancel()">&times;</a>
    </div>
    <div class="dialog-body">
        <div class="form-row" *ngIf="offer.is_activated && offer.end_date">
            <label>{{ 'shared.label.remaining-time' | translate }}</label>

            <app-countdown [date]="offer.end_date"></app-countdown>
        </div>

        <div class="form-row">
            <label>{{ 'shared.label.highlight-level' | translate }}</label>

            <ul class="form-checkbox-list">
                <li class="form-checkbox-item" *ngFor="let choice of highlight_levels" [class.active]="offer.highlight_level === choice">
                    <label>
                        <input type="radio" name="highlight" [value]="choice" [(ngModel)]="offer.highlight_level">
                        {{ 'shared.status.' + choice | translate }}
                    </label>
                </li>
            </ul>
        </div>

        <div class="buttons buttons-flex">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</a>
            <a class="button button-primary" (click)="onConfirm()">{{ 'shared.button.save' | translate }}</a>
        </div>
    </div>
</div>
